import React,{useState}  from 'react'
import {Box,Typography,Container,Button, Divider} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import create_assessment from '../Redux/reducers/create_assessment'
import {add_assessment,add_assessments} from "../Redux/templatesSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import dayjs from 'dayjs';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import TimeInput from '../Components/TimeInput';
import DateInput from '../Components/DateInput';
import { AddCard,FormatAlignCenter, AddCircleOutlined, FilePresentOutlined, MicRounded, PeopleAltOutlined } from '@mui/icons-material';
import EditorText from '../Components/EditorText';

function generate_id (){

	const c2 = Math.floor(Math.random()*10);
	const c3 = Math.floor(Math.random()*10);
	const c4 = Math.floor(Math.random()*10);
	const c1 = Math.floor(Math.random()*10);
	const c5 = Math.floor(Math.random()*10);
	const c6 = Math.floor(Math.random()*10);
	const c7 = Math.floor(Math.random()*10);
	const c8 = Math.floor(Math.random()*10);
  
	var result = `${c1}`+`${c2}`+`${c3}`+`${c4}`+`${c5}`+`${c6}`+`${c7}`+`${c8}`;
  
  return result
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    width:400,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }));

const AddParticipant = ()=>{

	const correction_types = ["AI","Myself"]

const theme = useTheme()
const assessments = useSelector(state => state?.templates.assessments);
const template = useSelector(state => state?.templates.template);
const [email,setEmail] = useState("")
const [name,setName] = useState("")
const [description, setDescription] = useState("");
const navigate = useNavigate()
const [loading, setLoading] = useState(false);
const [open, setOpen] = React.useState(false);
const [isInfo, setIsInfo] = React.useState(true);
const [aiType, setAiType] = React.useState("AI");
const [showDialog, setShowDialog] = React.useState(false);
const [duration, setDuration] = useState(null);
const [start_date, setStart_date] = useState("");
const [start_moment, setStart_moment] = useState(null);
const [message, setMessage] = React.useState("");
const [last_name, setLast_name] = React.useState("");
const [first_name, setFirst_name] = React.useState("");
const candidates = useSelector(state => state?.setting.candidates);
const [participants, setParticipants] = React.useState(candidates || []);

const user = useSelector(state => state?.auth.user);
const templates = useSelector(state => state?.templates.templates);
const dispatch = useDispatch()

const handleDiff = ()=>{
	const diff = dayjs(duration).diff(start_moment, 'minute');
	const start_mom = dayjs(start_moment).format("HH:mm");
	const end_mom = dayjs(duration).format("HH:mm");
	return {diff,start_mom,end_mom}
}


const handleCreate = async ()=>{
	try{
		if (isInfo) {
			setIsInfo(false)
		} else {
			if (participants?.length > 0) {

				const get_mom = handleDiff().start_mom
				const end_mom = handleDiff().end_mom
				const get_dur = handleDiff().diff
	
				const data = {
					id:generate_id(),
					templateId:template?.id,
					name:name,
					type:template?.type,
					category:template?.category,
					email:user?.email,
					aiCorrection:aiType === "AI" ? true : false,
					description:description,
					start_date:start_date,
					start_moment:get_mom,
					end_moment:end_mom,
					time:parseInt(get_dur),
					level:template?.level,
					users:[
					{
						email:user?.email,
						last_name:user?.last_name,
						first_name:user?.first_name,
						hasTook:false,
						hasFinished:false,
						isDisqualified:false,
						data:[]
					},
					...participants
					],
					reports:[],
					sections:[...template?.sections]
				}
	
				const token = user?.accessToken
	
				// console.log(data)
	
				create_assessment(dispatch,token,assessments,add_assessment,add_assessments,setOpen,setMessage,data,setLoading,navigate)
				
			} else {
				setMessage(`Please,make sure you add candidates that will take this assessment !`)
				setOpen(true)
			}
		}
	}catch(err){
		console.log(err)
	}
}

const handleAdd = ()=>{
	try{
		if (first_name !== "" && last_name !== "" && email !=="") {
            const data = {
				first_name:first_name,
				last_name:last_name,
				email:email,
				hasTook:false,
				hasFinished:false,
				isDisqualified:false,
				data:[]
			}
		
            const newData = [...participants,data]
        
            setParticipants(newData)
            setFirst_name("")
            setLast_name("")
            setEmail("")

		} else {
			setMessage("You have to fill all the form to add a participant")
			setOpen(true)
		}

	}catch(err){
		console.log(err)
	}
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

	return(
		<Box sx={{width:{xs:400,md:700}}}>
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Add an assessment</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
                <Box m={2} sx={{backgroundColor:"black",borderRadius:5,padding:2,width:'100%'}}>
					{
						isInfo ?
						<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
							Assessment detail
						</Typography>
						:
						<>
						<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
							Add Participants
						</Typography>
						<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
								<Box  display="flex"flexDirection="row" justifyContent="space-between" alignItems="center">
								<Typography style={{fontSize:15,fontWeight:400}}>
									{participants.length}
								</Typography>
									<IconButton onClick={(e)=>{
										e.preventDefault()
										setShowDialog(true)
									}} sx={{borderRadius:2,height:25}}>
										<PeopleAltOutlined/>
									</IconButton>								
								</Box>
							<Typography m={3} style={{fontSize:13,fontWeight:400,fontFamily:"dinofans"}}>
								Participant Detail
							</Typography>
						</Box>							
						</>
					}
						{
							isInfo ? 
							<GridViewContainer>
								<UserInput
									label="Title *"
									isPass={false}
									input={name}
									setInput={setName}
								>
									<FormatAlignCenter/>
								</UserInput>
								<UserInput
									label="Start date *"
									input={start_date}
									isDate={true}
									isPass={false}
									setInput={setStart_date}
								>
									<FormatAlignCenter/>
								</UserInput>
								<TimeInput
									label="start moment"
									input={start_moment}
									setInput={setStart_moment}
								/>
								<TimeInput
									label="End Moment *"
									input={duration}
									setInput={setDuration}
								/>
								<AutoInput
									data={correction_types}
									setInput={setAiType}
									input={aiType}
									label="Type of correction"
								/>
								<Box width="95%">
									<EditorText 
										title="Assessment description"
										data={description}
										setData={setDescription}
										width="95%"
										label="description"
										isRequired={true}
									/>
								</Box>
							</GridViewContainer>

							:

							<GridViewContainer>
								<UserInput
									label="Participant first name"
									isPass={false}
									input={first_name}
									setInput={setFirst_name}
								>
									<AccountCircle/>
								</UserInput>
								<UserInput
									label="Participant last name"
									input={last_name}
									isPass={false}
									setInput={setLast_name}
								>
									<AccountCircle/>
								</UserInput>
								<UserInput
									label="Participant email"
									input={email}
									isPass={false}
									setInput={setEmail}
								>
									<AccountCircle/>
								</UserInput>
								<Box width="100%">
									<Button sx={{background:"maroon",color:"#fff",mt:1,mb:1,height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} onClick={handleAdd} variant="contained">
										Add
									</Button>								
								</Box>
							</GridViewContainer>
						}
						<Divider/>
						<Button sx={{background:"gold",fontFamily:"dinofans",fontSize:12,marginTop:2}} disabled={loading ? true : false} onClick={handleCreate} >
							{
								loading ? <CircularProgress size={20} style={{color:"maroon"}}/> : (isInfo && !loading) ? "Next" :  "CREATE "
							}
						</Button>
				</Box>
				<CustomDialog handleUserDelete={(email)=>{
                    setParticipants(participants?.filter(item=>item?.email !== email))
                }} setData={setParticipants} data={participants} visible={showDialog} setVisible={setShowDialog}/>
			</Container>
		</Box>
		)
}

export default AddParticipant